import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Spinner from './Spinner'

interface Props {
  children: React.ReactNode
  adminOnly?: boolean
}

export default function ProtectedRoute({ children, adminOnly }: Props) {
  const { user, isLoading, isAdmin } = useAuth()

  if (isLoading) return <Spinner className="h-screen" />
  if (!user) return <div className="flex items-center justify-center h-screen text-tg-hint">Требуется авторизация</div>
  if (adminOnly && !isAdmin) return <Navigate to="/catalog" replace />

  return <>{children}</>
}
